/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function */

/**
 * eventCallback
 * @callback eventCallback
 * @param event
 */

import { Backend } from '../../api/Backend';
import { IProperty, IStreamManifestResponseV2 } from '../../api/models/AndromeTV.types';
import { AudioTrack, SeekRange, SubtitleTrack, VideoQuality } from './PlayerModel';

/**
 * Abstract service class used for different player engines
 */
export class PlayerService {
  /**
   * Starts player
   * @param {Backend} backend
   * @param {IStreamManifestResponseV2} manifest
   * @param {number} initialBitrate
   * @param {number} startTime
   * @returns {Promise<*>}
   * @abstract
   */
  start(
    backend: Backend,
    manifest: IStreamManifestResponseV2,
    initialBitrate: number,
    startTime: number | undefined
  ): Promise<any> {
    return Promise.resolve(undefined);
  }

  /**
   * Closes player
   * @abstract
   */
  close() {}

  bootstrap(): Promise<void> {
    return Promise.resolve();
  }

  /**
   * Adds eventListener to player
   * @param {PlayerEvent} event
   * @param {eventCallback} callback
   */
  on(event: string, callback: (event: any) => any) {}

  /**
   * Removes all eventListeners on player
   */
  removeEventListeners() {}

  /**
   * get absolute playback position in seconds, for live content it returns unix time
   */
  get absolutePosition(): number {
    return -1;
  }

  /**
   * get relative playback position in seconds to start of stream
   */
  get relativePosition(): number {
    return -1;
  }

  /**
   * get Current playback duration in seconds
   */
  get duration(): number {
    return -1;
  }

  /**
   * Seeks based on absolute time
   */
  seekAbsolute(time: number) {}

  get seekRange(): SeekRange | undefined {
    return undefined;
  }

  pause() {}

  play() {}

  configurePlaySpeed(speed: number) {}

  get videoQualities(): VideoQuality[] {
    return [];
  }

  get selectedVideoQuality(): VideoQuality | undefined {
    return undefined;
  }

  setVideoQuality(quality: VideoQuality) {}

  get audioTracks(): AudioTrack[] {
    return [];
  }

  get selectedAudioTrack(): AudioTrack | undefined {
    return undefined;
  }

  setAudioTrack(track: AudioTrack) {}

  get subtitleTracks(): SubtitleTrack[] {
    return [];
  }

  get selectedSubtitleTrack(): SubtitleTrack | undefined {
    return undefined;
  }

  setSubtitleTrack(track: SubtitleTrack) {}

  get isLive(): boolean {
    return false;
  }

  get playerReady(): boolean {
    return false;
  }

  DRMAnalyticsProperties(): IProperty[] {
    return [];
  }

  cleanup() {}
}
